<div class="mb-3">
  <mwe-infobox type="info" [messageKeys]="messageKeys" />
</div>

@if (errorMessageKey) {
  <div class="mb-3">
    @if (errorType === 'danger') {
      <mwe-inline-notification [type]="errorType" [messageKey]="errorMessageKey" [titleKey]="errorTitleKey" mweLookAtMeIAmTheFocusNow />
    } @else {
      <mwe-infobox [type]="errorType" [messageKey]="errorMessageKey" [titleKey]="errorTitleKey" mweLookAtMeIAmTheFocusNow />
    }
  </div>
}

<mwe-basic-card [hasBackground]="true" cardTitle="products-add.product-search.cardTitle" headingNodeType="h2">
  <ng-content />
  @if (formModel) {
    <div class="mt-3">
      <mwe-form [formModel]="formModel" [isLoading]="state === 'loading'" />
    </div>
  }
</mwe-basic-card>
<mwe-dsgvo-disclaimer class="d-block mt-5" />
